import { useDetectIframe } from '@guuru/chat-web';

const useHideMessageBar = (isUser, isFinished, partnerId) => {
  const inIframe = useDetectIframe();
  const hideMessageBar = isUser && isFinished && partnerId === 'olx-ua' && !inIframe;
  return { hideMessageBar };
};

export default useHideMessageBar;
